import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";

const ImageZoomCell = ({ slide }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      {/* MAIN IMAGE */}
      <div
        className="slick-slide border rounded p-2 d-flex align-items-center justify-content-center hi-image-frame"
        onClick={() => setShow(true)}
      >
        <img
          src={`${slide.image}?img=${slide.id}`}
          alt=""
          className="img-fluid hi-image-fit"
        />
      </div>

      {/* MODAL */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
      >
        <Modal.Body className="p-0 position-relative bg-dark">
          <div
            className="position-absolute top-0 end-0 p-2 hi-close-btn"
            onClick={() => setShow(false)}
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>

          <div className="d-flex align-items-center justify-content-center hi-image-frame hi-image-frame-modal">
            <img
              src={`${slide.image}?img=${slide.id}`}
              alt=""
              className="img-fluid hi-image-fit"
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ImageZoomCell;
